import { shallowRef } from 'vue'
import type { SupportPerson } from '@gat-ship/types'
import { useSupportApiCalls } from './useSupportApiCalls'

/**
 * Support personnel available for session assignment. Each call owns its
 * own lazily-fetched list — the create-session form is the only consumer
 * and shares a single instance between the picker and its
 * selected-person lookup.
 */
export function useSupportPersonnel() {
  const { getAllSupportPersonnelRequest } = useSupportApiCalls()

  const supportPersonnel = shallowRef<SupportPerson[]>([])

  /** Fetches the personnel list on first call; later calls are no-ops. */
  async function fetchSupportPersonnel() {
    if (supportPersonnel.value.length === 0) {
      const result = await getAllSupportPersonnelRequest()
      if (result) {
        supportPersonnel.value = result.personnel
      }
    }
  }

  return {
    supportPersonnel,
    fetchSupportPersonnel
  }
}
